import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import FaqForm from "../Form/FaqForm.js";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/faqs`;

export default function FaqList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  const formatDate = (date) =>
    date ? new Date(date).toLocaleString() : "N/A";

  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <button
          className="admin-btn outline"
          onClick={() => dispatch(openForm(null))}
        >
          + Add FAQ
        </button>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.map((faq) => (
            <div className="admin-card" key={faq.id}>
              <h4>{faq.question}</h4>
              <p>{faq.answer}</p>

              <p>Status: {faq.is_active ? "✅ Active" : "❌ Inactive"}</p>
              <p>Created By: {faq.createdByName}</p>
              <p>Created Time: {formatDate(faq?.createdTime)}</p>
              <p>Updated By: {faq?.lastModifiedByName}</p>
              <p>Updated Time: {formatDate(faq?.updatedTime)}</p>

              <div className="admin-card-actions">
                <button onClick={() => dispatch(openForm(faq.id))}>
                  ✏️
                </button>

                <button
                  onClick={() =>
                    window.confirm("Delete?") &&
                    dispatch(
                      callAPI({
                        method: "delete",
                        url: `${BASE_URL}/${faq.id}`,
                        data: { id: faq.id },
                      })
                    )
                  }
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <FaqForm />
    </div>
  );
}
